import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.gallery-hero-splide' ).length ) {
        $( '.gallery-hero-splide' ).each( function( _index, element ) {
          new Splide( element, {
            type: 'loop',
            perPage: 1,
            pagination: false,
            arrows: true,
            speed: 800,
          } ).mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'gallery-hero', COMPONENT );
} )( app );
